<template>
  <div style="color:white;">
    <div v-if="$store.getters.role=='Admin'">
      
   
    </div>
  <div style="padding:10px;" >
    <h4 style="text-align: left;color:#0f0c29;"><strong>Dashboard</strong></h4>
    <h4 style="text-align: left;color:#570827;">
    </h4>
    <b-row>
      <b-col md="12" style="padding-left: 10px;">
        <div>
               
            
              <div  >
                <div style="display:flex;justify-content: space-between;">
                <select name="" id="" @change="GetReportInit" style="float: left;">
                  <option value="t">Today</option>
                  <option value="w">Weekly</option>
                  <option value="m">Monthly</option>
                  <option value="y">Yearly</option>
                </select>
<div >
  <b-row no-gutters >
    <b-col md='auto' >
      <div style="float:left;">
<label  for="" style="color:black;padding-top:4px;margin-right:5px;">From :</label> <input type="date" name="" id="" placeholder="from" v-model="from" style="border:0.5px solid grey;border-radius: 5px;">
</div>
    </b-col>
    <b-col md='auto'>
      <div style="float:left;">
<label for="" style="color:black;padding-top:4px;margin-right:30px;margin-left:20px;">to :</label><input type="date" name="" id="" placeholder="to" v-model="to" style="border:0.5px solid grey;border-radius: 5px;">
      </div>
    </b-col>
    <b-col md="auto">
      <div >
<b-button class="btn btn-success btn-sm" @click="GetReportByDate" style="margin-left:10px;"> Filter</b-button>
      </div>
    </b-col>
  </b-row>
 </div>
</div>
</div>
<div >
  </div>
 
  
 
</div>
<b-row class="mt-4">
  <!-- Total Agents (Admin Only) -->
  <b-col md="4" class="mb-4" v-if="$store.getters.role === 'Admin'">
    <b-card class="dashboard-card">
      <b-row>
        <b-col md="3">
          <i class="mdi mdi-account-multiple icon-style"></i>
        </b-col>
        <b-col md="9">
          <div class="card-title">Total Agents</div>
          <h5 class="card-value">{{ formatNumber(dashboard.agent) }}</h5>
          <p class="card-label">Total Agents</p>
        </b-col>
      </b-row>
    </b-card>
  </b-col>

  <!-- Total Transactions (Admin Only) -->
  <b-col md="4" class="mb-4" v-if="$store.getters.role === 'Admin'">
    <b-card class="dashboard-card">
      <b-row>
        <b-col md="3">
          <i class="mdi mdi-cash-multiple icon-style"></i>
        </b-col>
        <b-col md="9">
          <div class="card-title">Total Transactions</div>
          <h5 class="card-value">{{ formatNumber(dashboard.transaction) }}</h5>
          <p class="card-label">Total Transaction</p>
        </b-col>
      </b-row>
    </b-card>
  </b-col>

  <!-- Total Countries (Admin Only) -->
  <b-col md="4" class="mb-4" v-if="$store.getters.role === 'Admin'">
    <b-card class="dashboard-card">
      <b-row>
        <b-col md="3">
          <i class="mdi mdi-earth icon-style"></i>
        </b-col>
        <b-col md="9">
          <div class="card-title">Total Countries</div>
          <h5 class="card-value">{{ formatNumber(dashboard.country) }}</h5>
          <p class="card-label">Total Country</p>
        </b-col>
      </b-row>
    </b-card>
  </b-col>

  <!-- On Hand -->
  <b-col md="4" class="mb-4">
    <b-card class="dashboard-card">
      <b-row>
        <b-col md="3">
          <i class="mdi mdi-wallet icon-style"></i>
        </b-col>
        <b-col md="9">
          <div class="card-title">On Hand</div>
          <h5 class="card-value">{{ formatNumber(dashboard.on_hand) }}</h5>
          <p class="card-label">Total On Hand</p>
        </b-col>
      </b-row>
    </b-card>
  </b-col>

  <!-- Total Paid -->
  <b-col md="4" class="mb-4">
    <b-card class="dashboard-card">
      <b-row>
        <b-col md="3">
          <i class="mdi mdi-currency-usd icon-style"></i>
        </b-col>
        <b-col md="9">
          <div class="card-title">Total Paid</div>
          <h5 class="card-value">{{ formatNumber(dashboard.paid) }}</h5>
          <p class="card-label">Total Paid</p>
        </b-col>
      </b-row>
    </b-card>
  </b-col>

  <!-- Total Pending -->
  <b-col md="4" class="mb-4">
    <b-card class="dashboard-card">
      <b-row>
        <b-col md="3">
          <i class="mdi mdi-timer-sand icon-style"></i>
        </b-col>
        <b-col md="9">
          <div class="card-title">Total Pending</div>
          <h5 class="card-value">{{ formatNumber(dashboard.pending) }}</h5>
          <p class="card-label">Total Pending</p>
        </b-col>
      </b-row>
    </b-card>
  </b-col>
</b-row>

        
      </b-col>
    </b-row>
  </div>



</div>
</template>
<script>
export default {
  data() {
    return {
      columns_S: [
        { label: "Number" },
        {
          label: "Full Name",
          field: "name"
        },
        {
          label: "Casher",
          field: "name"
        },
        {
          label: "ID",
          field: "SID"
        },
        {
          label: "Phone Number",
          field: "phone_number"
        },
        {
          label: "Grade",
          field: "grade"
        },
        {
          label: "Fee",
          field: "fee"
        },
        {
          label: "Class",
          field: "class"
        },
        {
          label: "Created At",
          field: "created_at"
        }
      ],
      columns: [
        { label: "Number" },
        { label: "Name", field: "name" },
        { label: "Phone Number", field: "phone_number" },
        { label: "Money", field: "money" },
        { label: "Manage", field: "manage" },
      ],
      columnsold: [
        { label: "Number" },
        { label: "Name", field: "name" },
        { label: "Phone Number", field: "phone_number" },
        { label: "Money", field: "money" }
      ],
json_fields_payed:{
        'Name':{
                callback: (value) => {
                    return ` ${value.students.first_name+' '+value.students.middle_name+' '+value.students.last_name}`;
                }
            },
        'Phone Number':{
                callback: (value) => {
                    return ` ${value.students.phone_number}`;
                }
            },
        'Money':'amount'
      },
      json_fields_payed_delivery:{
        'Name':{
                callback: (value) => {
                    return ` ${value.user.first_name+' '+value.user.middle_name+' '+value.user.last_name}`;
                }
            },
        'Description':'description',
          'Price':'amount',
        'Created At':'created_at',
      },
      json_fields_payed_delivery_both:{
        'Name':{
                callback: (value) => {
                    return ` ${value.user.first_name+' '+value.user.middle_name+' '+value.user.last_name}`;
                }
            },
        'Phone Number':{
                callback: (value) => {
                    return ` ${value.user.phone_number}`;
                }
            },
        'Description':'description',
        'Money':'amount',
        'Created At':'created_at',
      },
      json_data_payed:[],
      json_meta:[
        [
          {
            'key':'charset',
            'value':'utf-8'
          }
        ]
      ],
      user:{'0':0,'1':0,'2':0},
      url:'',
      students:[],
      loading:false,
      reported_date:'',
      filename:'',
      banks:[],
      dashboard:{
        country:0,
        transaction:0,
        on_hand:0,
        pending:0,
        paid:0,
        agent:0
      },
      iscasherold:false,
      iscasher:false,
      isreported:false,
      report_folder:[],
      casher:true,
      casher_report:[],
      store_report:[],
      casher_graph:[],
      store_graph:[],
      cahrt_holder:null,
      from:'',
        to:'',
    };
  },
  beforeMount() {
  },
  mounted(){
    if(this.$store.getters.role=='User')
    this.getUserProfile()

  if(this.$store.getters.role=='Admin'){
    this.GetReport(1)
  }
  },
  methods: {
    formatNumber(value) {
    if (!value) return '0';
    return new Intl.NumberFormat('en-US').format(value);
  },
    getUserProfile(){
         this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_get_my_profile','variable':'users'}, { root: true }).then(() => {
        this.user=this.$store.getters['admin/Getusers']
        this.url=window.image_url+this.user.image
      })
      },
    filterbyreportfolder(e){
      this.reported_date=e.target.value
      this.GetReport(this.active)
    }, 
    Done(row,index){
      window.Swal.fire({
            title: 'are you sure',
            text: 'the Money is equal',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
          }).then((result) => {
            if (result.value) {
       this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_done_casher','variable':'status','params':row.user_id}, { root: true }).then(() => {
        window.Toast.fire({
            icon: "success",
            title:'Casher Updated successfuly',
          });
          this.casher_report.splice(index,1)
        
        })
      }
     });
    },
    loadMoneyBank(){
      this.$store.dispatch('admin/AdminController',{'data':{from:this.from,to:this.to,isreported:this.isreported,ismain:this.ismain,reported_date:this.reported_date},'method':'post','api':'admin_filter_date_casher_report_bank','variable':'report','params': this.active}, { root: true }).then(() => {
        this.banks=this.$store.getters['admin/GetReport']
      })
    },
    closemoadl(val){
      this.$bvModal.hide(val)
    },
    GetReportprintInit(e){
        if(e.target.value==1){
          this.exportexpayed()
        }else if(e.target.value==2){
          this.exportexflaged()
        }else if(e.target.value==3){
            this.exportexpayedDelivery()
        }else if(e.target.value==4){
          this.exportexflagedDelivery()
        }
    },
    exportexpayed(){
      this.loading=true
      this.$store.dispatch('admin/AdminController',{'data':{from:this.from,to:this.to,isreported:this.isreported,ismain:this.ismain,reported_date:this.reported_date},'method':'post','api':'admin_get_all_payed_orders','variable':'items','params':this.active}, { root: true }).then(() => {
        this.json_data_payed=this.$store.getters['admin/Getitems']
        setTimeout(()=>{
           document.getElementById('export-log-to-xl').click()
        this.loading=false
         if(!this.json_data_payed.length){
           window.Toast.fire({
            icon: "warning",
            title:'Report is empity !!',
          });
        }
        },2000) 
      }).catch(() => {
        this.loading=false;
        });
    },
    exportexflaged(){
      this.loading=true
      this.$store.dispatch('admin/AdminController',{'data':{from:this.from,to:this.to,isreported:this.isreported,ismain:this.ismain,reported_date:this.reported_date},'method':'post','api':'admin_get_all_expense_orders','variable':'items','params':this.active}, { root: true }).then(() => {
        this.json_data_payed=this.$store.getters['admin/Getitems']
        setTimeout(()=>{
           document.getElementById('export-log-flagged-to-xl').click()
        this.loading=false
         if(!this.json_data_payed.length){
           window.Toast.fire({
            icon: "warning",
            title:'Expense is empity !!',
          });
        }
        },2000) 
      })
    },
    exportexpayedDelivery(){
      this.loading=true
      this.$store.dispatch('admin/AdminController',{'data':{from:this.from,to:this.to,isreported:this.isreported,ismain:this.ismain,reported_date:this.reported_date},'method':'post','api':'admin_get_all_expense_orders_both','variable':'items','params':this.active}, { root: true }).then(() => {
        this.json_data_payed=this.$store.getters['admin/Getitems']
        setTimeout(()=>{
           document.getElementById('export-log-flagged-to-xlrep').click()
        this.loading=false
         if(!this.json_data_payed.length){
           window.Toast.fire({
            icon: "warning",
            title:'Expense and Income are empity !!',
          });
        }
        },2000) 
      })
    },
    exportexflagedDelivery(){
      this.loading=true
      this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_get_all_flagged_Dorders','variable':'items'}, { root: true }).then(() => {
        this.json_data_payed=this.$store.getters['admin/Getitems']
        setTimeout(()=>{
           document.getElementById('export-flaged-delivery-to-xl').click()
        this.loading=false
         if(!this.json_data_payed.length){
           window.Toast.fire({
            icon: "warning",
            title:'Flagged Orders is empity !!',
          });
        }
        },2000) 
      })
    },
    GetReportByDate(){
      this.GetReport(this.active)
      },
    getREportFolder(){
         this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_get_report_folder','variable':'report'}, { root: true }).then(() => {
          this.report_folder=this.$store.getters['admin/GetReport']
      })
      },
      GetReportInit(e){
        switch(e.target.value){
          case 't':
          this.GetReport(1);
          break;
          case 'w':
          this.GetReport(2);
          break;
          case 'm':
          this.GetReport(3);
          break;
          case 'y':
          this.GetReport(4);
          break;
        }
      },
      GetReport(id){
        this.active=id
      this.loading=true
        var url='admin_get_report_cahser'
        this.$store.dispatch('admin/AdminController',{'data':{from:this.from,to:this.to,isreported:this.isreported,ismain:this.ismain,reported_date:this.reported_date},'method':'post','api':url,'variable':'report','params':id}, { root: true }).then(() => {
          this.dashboard=this.$store.getters['admin/GetReport']
         
      this.loading=false
      }).catch(() => {
        this.loading=false;
        });
      },
      DeleteReport(){
        window.Swal.fire({
            title: 'are you sure',
            text: 'you want to delete this Report',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
          }).then((result) => {
            if (result.value) {
              this.loading=true
        var url='admin_get_report_delete'
        this.$store.dispatch('admin/AdminController',{'data':{from:this.from,to:this.to,isreported:this.isreported,ismain:this.ismain,reported_date:this.reported_date},'method':'post','api':url,'variable':'status','params':this.active}, { root: true }).then(() => {
          window.Toast.fire({
            icon: "success",
            title:'Report Deleted successfuly',
          });
      this.loading=false
      }).catch(() => {
        this.loading=false;
        });
    
            }
     });
     
      },
      getchaserreport(){
        var url='admin_get_report_cahser'
        this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':url,'variable':'users'}, { root: true }).then(() => {
          this.casher_report=this.$store.getters['admin/Getusers']
      this.loading=false
      }).catch(() => {
        this.loading=false;
        });
      },
    Reported(){
        this.loading=true
         var api='admin_reported'
      this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':api,'variable':'status'}, { root: true }).then(() => {
         this.GetReport(1)
  this.loading=false
      }).catch(() => {
        this.loading=false;
        });
      },
  },
};
</script>
<style scoped>
.loading{
  color:white;
  font-size:1.3em;
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  z-index: 3000;
  right: 0;
  background: rgba(0.5,0.5,0.5,0.5);
}
select {
  height: 40px;
  border: 0.5px solid #ccc;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  font-size: 16px;
  color: #000;
}

select:hover {
  border-color: #000;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

select option {
  padding: 10px;
  cursor: pointer;
}

select option:hover {
  background-color: #ccc;
} 
.panel{
    
  background: linear-gradient(to right, #0f2027, #203a43, #2c5364);
  padding: 0;
  border-radius: 10px;
  border: none;
  box-shadow: 0 0 0 5px rgba(0,0,0,0.05),0 0 0 10px rgba(0,0,0,0.05);
}
.panel .panel-heading{
  padding: 20px 15px;
  border-radius: 10px 10px 0 0;
  margin: 0;
}
.panel .panel-heading .title{
  color: #fff;
  font-size: 28px;
  font-weight: 500;
  text-transform: capitalize;
  line-height: 40px;
  margin: 0;
}
.panel .panel-heading .btn{
  color: rgba(255,255,255,0.5);
  background: transparent;
  font-size: 16px;
  text-transform: capitalize;
  border: 2px solid #fff;
  border-radius: 50px;
  transition: all 0.3s ease 0s;
}
.panel .panel-heading .btn:hover{
  color: #fff;
  text-shadow: 3px 3px rgba(255,255,255,0.2);
}
.panel .panel-heading .form-control{
  color: #fff;
  background-color: transparent;
  width: 35%;
  height: 40px;
  border: 2px solid #fff;
  border-radius: 20px;
  display: inline-block;
  transition: all 0.3s ease 0s;
}
.panel .panel-heading .form-control:focus{
  background-color: rgba(255,255,255,0.2);
  box-shadow: none;
  outline: none;
}
.panel .panel-heading .form-control::placeholder{
  color: rgba(255,255,255,0.5);
  font-size: 15px;
  font-weight: 500;
}
.panel .panel-body{ padding: 0; }
.panel .panel-body .table thead tr th{
  color: #fff;
  background-color: rgba(255, 255, 255, 0.2);
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  padding: 12px;
  border: none;
}
.panel .panel-body .table tbody tr td{
  color: #fff;
  font-size: 15px;
  padding: 10px 12px;
  vertical-align: middle;
  border: none;
}
.panel .panel-body .table tbody tr:nth-child(even){ background-color: rgba(255,255,255,0.05); }
.panel .panel-body .table tbody .action-list{
  padding: 0;
  margin: 0;
  list-style: none;
}
.panel .panel-body .table tbody .action-list li{
  display: inline-block;
  margin: 0 5px;
}
.panel .panel-body .table tbody .action-list li a{
  color: #fff;
  font-size: 15px;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease 0s;
}
.panel .panel-body .table tbody .action-list li a:hover{ text-shadow: 3px 3px 0 rgba(255,255,255,0.3); }
.panel .panel-body .table tbody .action-list li a:before,
.panel .panel-body .table tbody .action-list li a:after{
  content: attr(data-tip);
  color: #fff;
  background-color: #111;
  font-size: 12px;
  padding: 5px 7px;
  border-radius: 4px;
  text-transform: capitalize;
  display: none;
  transform: translateX(-50%);
  position: absolute;
  left: 50%;
  top: -32px;
  transition: all 0.3s ease 0s;
}
.panel .panel-body .table tbody .action-list li a:after{
  content: '';
  height: 15px;
  width: 15px;
  padding: 0;
  border-radius: 0;
  transform: translateX(-50%) rotate(45deg);
  top: -18px;
  z-index: -1;
}
.panel .panel-body .table tbody .action-list li a:hover:before,
.panel .panel-body .table tbody .action-list li a:hover:after{
  display: block;
}
.panel .panel-footer{
  color: #fff;
  background-color: transparent;
  padding: 15px;
  border: none;
}
.panel .panel-footer .col{ line-height: 35px; }
.pagination{ margin: 0; }
.pagination li a{
  color: #fff;
  background-color: transparent;
  border: 2px solid transparent;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  line-height: 31px;
  width: 35px;
  height: 35px;
  padding: 0;
  margin: 0 3px;
  border-radius: 50px;
  transition: all 0.3s ease 0s;
}
.pagination li a:hover{
  color: #fff;
  background-color: transparent;
  border-color: rgba(255,255,255,0.2);
}
.pagination li a:focus,
.pagination li.active a,
.pagination li.active a:hover{
  color: #fff;
  background-color: transparent;
  border-color: #fff;
}
.pagination li:first-child a,
.pagination li:last-child a{
  border-radius: 50%;
}
@media only screen and (max-width:767px){
  .panel .panel-heading .title{
      text-align: center;
      margin: 0 0 10px;
  }
  .panel .panel-heading .btn_group{ text-align: center; }
}

.dashboard-card {
  border: 0;
  border-radius: 10px;
  background:  linear-gradient(to top, #11232c, #203a43, #023244);
  color: white;
}

.icon-style {
  font-size: 2em;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.card-title {
  text-align: left;
  font-size: 0.9em;
  font-weight: bold;
}

.card-value {
  text-align: left;
  font-size: 1.2em;
  font-weight: bold;
  margin: 5px 0;
}

.card-label {
  text-align: left;
  font-size: 0.85em;
  margin-bottom: -10px;
  opacity: 0.8;
}


</style>


